import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/my-styles')({
  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.styles.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    // Lives here, not in `(pages)`: this layout owns the `/my-styles` segment,
    // so a pathless child never matches the bare path and nothing would render.
    if (
      location.pathname === '/my-styles' ||
      location.pathname === '/my-styles/'
    ) {
      throw redirect({ to: '/my-styles/styles/active' });
    }
  },
});
